import moment from "moment-timezone";

export const axiosConfigHeaders = (acceptVersion = "") => ({
  headers: {
    "x-time-zone": moment.tz.guess(),
    Accept: `application/json${acceptVersion ? ";" + acceptVersion : ""}`,
  },
});
